import React from 'react';
import { StarIcon } from 'lucide-react';
import { initials } from '../data/coaches';
type Testimonial = {
  headline?: string;
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  background?: 'white' | 'cream';
};
export function Testimonials({
  testimonials,
  title = 'What coaches are saying',
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-ice';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-238" data-mp="31zmqjz86zriq">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-239" data-mp="2x0jngkbrvvde">
        <div className="text-center" data-id="element-240" data-mp="2x11r420rlbvc">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-241" data-mp="2s1ynmm0fndph">
            Coach to coach
          </p>
          <h2 className="chalk-underline mt-3 font-display text-ink text-[28px] sm:text-5xl" data-id="element-242" data-mp="v8dmppcdwidz">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-243" data-mp="qb4zhacdpo5v">
            Rated 4.9/5 by 1,200+ coaches across school clubs, after-school
            programs and community chess clubs.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-244" data-mp="77s6dvyzi4y8">
          {testimonials.map((item, i) => <figure key={i} className="rounded-2xl border border-ice-dark bg-white p-5 shadow-card" data-id="element-245" data-mp="c6loy2t4om59" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-246" data-mp="zwy3hwivph4t">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-ice-dark" data-id="element-247" data-mp="14u7qz6mpjiq0" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy font-display text-[13px] text-gold" data-id="element-248" data-mp="1it7do8qntnjj">
                    {initials(item.author)}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-249" data-mp="1sj5v5hpjqv1v">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-250" data-mp="1og9jkayfbz7f" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm text-ink" data-id="element-251" data-mp="1ekzhjn80zrtn">
                {item.headline ? <p className="mb-2 text-base font-bold leading-snug text-ink" data-id="element-252" data-mp="19qlh36eiaui4">
                    “{item.headline}”
                  </p> : null}
                <div className="space-y-2 italic" data-id="element-253" data-mp="10t1bxmdiwe28">
                  {item.quote.split('\n\n').map((paragraph, p) => <p key={p} data-id="element-254" data-mp="vuq4tjem4hnp" data-mpi={p}>{paragraph}</p>)}
                </div>
              </blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-255" data-mp="qvwrbqzbsqnj">
                <span className="block text-[13px] font-bold not-italic text-ink" data-id="element-256" data-mp="32ge0uyp90xv0">
                  {item.author}
                </span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}